import { mount } from '@vue/test-utils';
import LoginDetails from './LoginDetails';
const faker = require('faker');

describe('Login Details Template', () => {

    let wrapper = '';

    it('Sets the password to "Not set" if it isnt provided', () => {
        wrapper = mount(LoginDetails);
        expect(wrapper.html()).toContain('Not set');
    });

    it('Sets the username to root if it isnt provided', () => {
        wrapper = mount(LoginDetails);
        expect(wrapper.vm.username).toBe('root');
    });

    it('Displays the username', () => {
        let testUser = `${faker.name.firstName} ${faker.name.lastName}`;
        wrapper = mount(LoginDetails, {
            propsData: {
                username: testUser
            }
        });
        expect(wrapper.html()).toContain(testUser);
    });

    it('Sets the port to 2929 if it isnt provided', () => {
        wrapper = mount(LoginDetails);
        expect(wrapper.vm.port).toBe(2929);
    });

    it('Displays the port', () => {
        let testPort = faker.random.number();
        wrapper = mount(LoginDetails, {
            propsData: {
                port: testPort
            }
        });
        expect(wrapper.html()).toContain(testPort);
    })

});
